import img from './img.png';
import {useEffect, useState} from "react";
import styles from './Login.module.css';
import HttpService from "../Services/HttpService";
import cookies from "../Services/cookies";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

function Login() {

    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [isForgetPass, setForgetPass] = useState(false);
    const cookie = cookies();
    const navigate = useNavigate();

    const onLogin = (e) => {
        e.preventDefault();

        HttpService.post(`User/Login?email=${user}&pass=${pass}`)
            .then(response => {
                console.log(response);
                if (response.status === 200) {
                    cookie.set('token', response.data);
                    toast.success('ورود شما با موفقیت انجام شد.');
                    navigate('/');
                }
            })
            .catch(error => {
                if (error.status === 404) {
                    toast.warn('نام کاربری یا رمز عبور اشتباه است');
                } else {
                    toast.error('خطا در دریافت اطلاعات، دوباره تلاش نمایید');
                }
            });
    };

    const onForgetPass = (e) => {
        e.preventDefault();

    }


    return (<div className={styles.container}>
        <div className={styles.container_image}>
            <h1>موقعیت | مرجع آگهی آنلاین</h1>
            <img src={img} alt=''/>
        </div>
        {!isForgetPass ?
            <div className={styles.container_login}>
                <form onSubmit={onLogin} className={styles.form}>
                    <h4>ایمیل</h4>
                    <input
                        type="text"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                        required
                        className={styles.input}
                    />
                    <h4>رمز عبور</h4>
                    <input
                        type="password"
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        required
                        className={styles.input}
                    />
                    <button type="submit" className={styles.button}>ورود</button>
                    <h4
                        onClick={() => setForgetPass(true)}
                        role="button"
                        style={{
                            cursor: 'pointer',
                        }}
                    >
                        فراموشی رمز عبور
                    </h4>

                </form>
            </div>
            :
            <div className={styles.container_forgetPass}>
                <form onSubmit={onForgetPass} className={styles.form}>
                    <h4>شماره همراه</h4>
                    <input
                        type="text"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                        required
                        className={styles.input}
                    />
                    <button type="submit" className={styles.button}>ارسال</button>
                    <h4
                        onClick={() => setForgetPass(false)}
                        role="button"
                        style={{
                            cursor: 'pointer',
                        }}
                    >
                        ورود به حساب
                    </h4>

                </form>
            </div>}
    </div>);
}


export default Login;